import AEMWrapper from "aem/ComponentWrapper";
// import ContainerWrapper from "concierge-alias-aem/ContainerWrapper"; // Using the same ContainerWrapper as Box2
import meta from "./aem-meta";
import Component from "./aem-component"; // This is our AEMTabsComponent

export default AEMWrapper(meta, Component);
